<div class="operators-panel" tabindex="-1">
  <div class="operators-list-content">
    <div class="search-box">
      <div class="inner-addon left-addon input-search">
        <svg-icon icon="magnifier" class="bc-search-icon"></svg-icon>
        <input matInput #searchInput [(ngModel)]="searchField"
               (ngModelChange)="searchFilterChanged()"
               [ngModelOptions]="{ updateOn: 'change' }"
               class="form-control searchfield"
               placeholder="{{ 'operatorsList.searchPlaceholder' | translate }}"
               [attr.data-automation-id]="'bc-operator-list-search'"/>
        <span *ngIf="searchField" class="icon fa fa-times-circle" (click)="resetSearch()"></span>
      </div>
    </div>

    <app-loading class="operators-panel-list bc-list" *ngIf="!departments"></app-loading>
    <cdk-virtual-scroll-viewport #virtualOperatorList
                                 [itemSize]="LIST_ITEM_SIZE"
                                 [minBufferPx]="300"
                                 [maxBufferPx]="500"
                                 class="operators-panel-list">
      <div *cdkVirtualFor="let listItem of listItems; let key = index; trackBy: trackByItemId"
           class="list-item list-item-{{key}}"
           (mouseenter)="setSelectedIndex(key)"
           [ngClass]="getListItemClass(key, listItem)">

        <svg-icon *ngIf="listItem.type === DEPARTMENT_ITEM_TYPE && listItem.item !== acdItem"
                  icon="{{ listItem.item.collapsed ? 'arrow-right' : 'arrow-down'}}"
                  class="department-arrow"
                  (click)="toggleDepartmentCollapsed(listItem.item)"
                  [attr.data-automation-id]="'bc-operator-list-department-collapse-toggle'"></svg-icon>

        <div (click)="selectItem(listItem.item)"
             [ngClass]="['bc-transfer-target', 'status-' + listItem.item.availability[getWorkItemAvailabilityKey()]]">
          <div title="{{ createTooltipText(listItem) }}"
               class="item-activity">
            <div class="bc-status-circle status-{{listItem.item.availability[getWorkItemAvailabilityKey()]}}"
                 [ngClass]="{ 'busy': listItem.type === OPERATOR_ITEM_TYPE && !listItem.item.selected && !!getOperatorActiveItemsCount(listItem.item.id) }"
                 attr.data-automation-id="bc-{{getListItemClass(key, listItem)}}-status-circle-{{listItem.item.availability[getWorkItemAvailabilityKey()]}}">
              <svg-icon *ngIf="listItem.item.selected" icon="checkmark"></svg-icon>
            </div>
            <div class="active-items-count"
                 *ngIf="isItemCountDisplayed(listItem)">{{ getOperatorActiveItemsCount(listItem.item.id) }}</div>
          </div>

          <div class="item-display-name status-{{listItem.item.availability[getWorkItemAvailabilityKey()]}}"
               [innerText]="getItemDisplayName(listItem)"
               attr.data-automation-id="bc-operator-list-{{getListItemClass(key, listItem)}}-name"></div>

          <div *ngIf="listItem.type === DEPARTMENT_ITEM_TYPE && listItem.item !== acdItem" class="operator-count status-{{listItem.item.availability[getWorkItemAvailabilityKey()]}}">
            <span class="js-available-operators" [attr.data-automation-id]="'bc-operator-list-available-operators'">{{'(' + getAvailableOperatorCount(listItem.item) + '/'}}</span>
            <span class="js-total-operators" [attr.data-automation-id]="'bc-operator-list-total-operators'">{{ getUnfilteredOperatorCount(listItem.item) + ')'}}</span>
          </div>
        </div>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
